'use strict';

var base58 = require('multiformats/bases/base58');
var base64 = require('multiformats/bases/base64');
var base32 = require('multiformats/bases/base32');
var base16 = require('multiformats/bases/base16');

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const parseMultibase = /* @__PURE__ */ __name(async (multibase) => {
  const [prefix, ..._value] = multibase;
  const supportedBases = [
    base58.base58btc,
    base64.base64,
    base64.base64pad,
    base64.base64url,
    base64.base64urlpad,
    base32.base32,
    base32.base32hex,
    base32.base32hexpad,
    base32.base32hexpadupper,
    base32.base32hexupper,
    base32.base32pad,
    base32.base32padupper,
    base32.base32upper,
    base32.base32z,
    base16.base16,
    base16.base16upper
  ];
  const base = supportedBases.find((base2) => base2.prefix === prefix);
  if (!base) {
    throw new Error("Unsupported multibase");
  }
  return base.decode(multibase);
}, "parseMultibase");
const getDomain = /* @__PURE__ */ __name((domain) => {
  if (!domain || domain.trim() === "") {
    return void 0;
  }
  try {
    const parsedUrl = domain.startsWith("http") ? domain : "http://" + domain;
    const url = new URL(parsedUrl);
    if (!url.hostname.includes(".")) {
      return void 0;
    }
    return url.hostname + (url.pathname !== "/" ? url.pathname : "");
  } catch (error) {
    return void 0;
  }
}, "getDomain");

exports.getDomain = getDomain;
exports.parseMultibase = parseMultibase;
